export type FilterElementId = 'filter' | 'priceRange';

export interface FilterLayoutConfig {
  filterEnabled: boolean;
  filterVisible: boolean;
  priceRangeEnabled: boolean;
  priceRangeVisible: boolean;
}

export const DEFAULT_FILTER_LAYOUT_CONFIG: FilterLayoutConfig = {
  filterEnabled: false,
  filterVisible: true,
  priceRangeEnabled: true,
  priceRangeVisible: true,
};

/** Admin preview always shows all filter blocks regardless of default-open settings. */
export const FILTER_LAYOUT_PREVIEW_CONFIG: FilterLayoutConfig = {
  filterEnabled: true,
  filterVisible: true,
  priceRangeEnabled: true,
  priceRangeVisible: true,
};

export function normalizeFilterLayoutConfig(payload: unknown): FilterLayoutConfig {
  const root =
    payload != null && typeof payload === 'object' && !Array.isArray(payload)
      ? (payload as Record<string, unknown>)
      : {};

  return {
    filterEnabled: readBoolean(root['filterEnabled'], DEFAULT_FILTER_LAYOUT_CONFIG.filterEnabled),
    filterVisible: readBoolean(root['filterVisible'], DEFAULT_FILTER_LAYOUT_CONFIG.filterVisible),
    priceRangeEnabled: readBoolean(
      root['priceRangeEnabled'],
      DEFAULT_FILTER_LAYOUT_CONFIG.priceRangeEnabled,
    ),
    priceRangeVisible: readBoolean(
      root['priceRangeVisible'],
      DEFAULT_FILTER_LAYOUT_CONFIG.priceRangeVisible,
    ),
  };
}

function readBoolean(value: unknown, fallback: boolean): boolean {
  return typeof value === 'boolean' ? value : fallback;
}

/** Customer catalog routes where the specification filter sidebar is available. */
export function isCustomerSpecFilterRoute(url: string): boolean {
  const path = url.split('?')[0];
  return path.includes('/customer/CFProduct/product-view') || path.includes('/sub-category/');
}
